export default "__VITE_ASSET__Bk5Pg9Es__"